var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _ellipse, _rect4, _rect5, _rect6, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyVoucher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8125,
    cy: 75.9376,
    r: 47.0089,
    fill: "#FFE7E7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.75,
    cy: 44.1967,
    r: 2.94643,
    fill: "#FFE7E7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 109.955,
    cy: 32.5448,
    r: 5.49107,
    fill: "#FFE7E7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6874,
    cy: 106.205,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 128.17,
    cy: 101.116,
    r: 5.22321,
    fill: "#FFE7E7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.991,
    cy: 107.009,
    r: 2.54464,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.3192 30.9476C85.1639 30.9145 85.1639 30.6929 85.3192 30.6599L87.6672 30.1606C87.7238 30.1485 87.7681 30.1044 87.7803 30.0479L88.2859 27.7165C88.3194 27.562 88.5398 27.562 88.5733 27.7165L89.0789 30.0479C89.0911 30.1044 89.1354 30.1485 89.192 30.1606L91.5399 30.6599C91.6952 30.6929 91.6952 30.9145 91.5399 30.9476L89.192 31.4469C89.1354 31.4589 89.0911 31.503 89.0789 31.5595L88.5733 33.8909C88.5398 34.0455 88.3194 34.0455 88.2859 33.8909L87.7803 31.5595C87.7681 31.503 87.7238 31.4589 87.6672 31.4469L85.3192 30.9476Z",
    fill: "#F8AFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4883 82.9346C21.5482 82.6514 21.9524 82.6514 22.0124 82.9346L22.9078 87.1647C22.9296 87.2678 23.0098 87.3485 23.1128 87.371L27.2993 88.283C27.5804 88.3442 27.5804 88.7452 27.2993 88.8064L23.1128 89.7184C23.0098 89.7409 22.9296 89.8216 22.9078 89.9247L22.0124 94.1548C21.9524 94.438 21.5482 94.438 21.4883 94.1548L20.5929 89.9247C20.5711 89.8216 20.4908 89.7409 20.3878 89.7184L16.2014 88.8064C15.9203 88.7452 15.9203 88.3442 16.2014 88.283L20.3878 87.371C20.4908 87.3485 20.5711 87.2678 20.5929 87.1647L21.4883 82.9346Z",
    fill: "#F8AFAF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.824 45.4346C119.884 45.1514 120.289 45.1514 120.349 45.4346L120.871 47.9023C120.893 48.0054 120.973 48.0861 121.076 48.1086L123.525 48.6422C123.806 48.7034 123.806 49.1043 123.525 49.1656L121.076 49.6992C120.973 49.7216 120.893 49.8023 120.871 49.9054L120.349 52.3732C120.289 52.6564 119.884 52.6564 119.824 52.3732L119.302 49.9054C119.28 49.8023 119.2 49.7216 119.097 49.6992L116.648 49.1656C116.367 49.1043 116.367 48.7034 116.648 48.6422L119.097 48.1086C119.2 48.0861 119.28 48.0054 119.302 47.9023L119.824 45.4346Z",
    fill: "#F8AFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.623 84.9995L131.443 88.8747L135.263 89.7069L131.443 90.539L130.623 94.4142L129.802 90.539L125.983 89.7069L129.802 88.8747L130.623 84.9995Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59.6335,
    y: 57.5896,
    width: 52.9169,
    height: 18.8661,
    rx: 6.42857,
    fill: "#F9C5C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 81.4772,
    y: 64.0845,
    width: 17.8441,
    height: 2.47424,
    rx: 1.23712,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64.2484,
    y: 67.7959,
    width: 35.1628,
    height: 2.47425,
    rx: 1.23712,
    fill: "#FFE1E1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 105.782,
    cy: 67.1773,
    rx: 3.07657,
    ry: 3.09281,
    fill: "#F8AFAF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 73.3628,
    width: 52.9169,
    height: 18.8661,
    rx: 6.42857,
    fill: "#FFD5D5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7292,
    y: 79.8577,
    width: 17.8441,
    height: 2.47424,
    rx: 1.23712,
    fill: "#F8AFAF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7292,
    y: 83.5691,
    width: 35.1628,
    height: 2.47425,
    rx: 1.23712,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.1914,
    cy: 82.9505,
    rx: 3.07656,
    ry: 3.09281,
    fill: "#F8AFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyVoucher);
export default __webpack_public_path__ + "static/media/empty_voucher.2f1147fefe647a015fa88b2f0fa8c8ec.svg";
export { ForwardRef as ReactComponent };